/**!
 * Apricot D8
 * @version 2
 * @author Mitra Assadi
 * @license
 * Copyright (c) 2021 The College Board
 */

/* ========================================================================
 * Apricot's D8
 * ======================================================================== */

// SCSS
import '../scss/includes/apricot-d8.scss';

// javaScript
export default {};
